import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Modal } from 'reactstrap';
import SkillEditDialogHeader from './SkillViewDialogHeader';
import api from '@/utils/apiClient';
import { SkillViewBasicDetails } from './SkillViewBasicDetails';
import { SkillViewTabs } from './SkillViewTabs';
import LoadingIcon from 'mdi-react/LoadingIcon';

const SkillViewDialog = ({ show, onHide, id, rtl }) => {
  const [modal, setModal] = useState({
    isOpen: show,
    title: 'View Skill',
    hide: onHide,
  });

  const [state, setState] = React.useState({
    loading: false,
    skill: {},
    error: '',
  });

  React.useEffect(() => {
    if (id) getSkillById(+id);
  }, [id]);

  const getSkillById = async (skillId) => {
    try {
      setState({ ...state, loading: true });
      const { data: res, isSuccess } = await api.skills.getSkill(skillId);
      if (isSuccess) {
        setState({ ...state, loading: false, skill: res.data, error: '' });
      } else {
        throw new Error(res?.messages?.[0] ?? 'Error while getting skill details');
      }
    } catch ({ message }) {
      setState({ ...state, loading: false, skill: {}, error: message });
      console.error(message);
    }
  };

  const { error, loading, skill } = state;

  return (
    <Modal
      isOpen={show}
      toggle={modal.hide}
      modalClassName={`${rtl.direction}-support`}
      className="modal-dialog--primary modal-dialog--header modal-view-dialog"
    >
      <SkillEditDialogHeader modal={modal} skill={skill} />
      {/*Skill Modal Body*/}
      <div style={{ padding: 15 }}>
        {loading || !!error ? (
          <>
            {loading && (
              <div className="panel__refresh position-relative" style={{ height: 75 }}>
                <LoadingIcon />
              </div>
            )}
            <div className="text-center">
              {error && (
                <div>
                  <span className="lnr lnr-cross-circle modal__title-icon error" />
                </div>
              )}
              {loading ? 'Getting skill details...' : error}
            </div>
          </>
        ) : (
          <>
            <SkillViewBasicDetails skill={skill} />
            <SkillViewTabs competencies={skill?.competencies} />
          </>
        )}
      </div>
    </Modal>
  );
};

export default connect((state) => ({
  rtl: state.rtl,
}))(SkillViewDialog);
